import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/success.png'


const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px"} }, "为方便提供服务，请确认授权", -1)
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "form-title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "step-box-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "has-submit" }, "已提交", -1)
const _hoisted_12 = { class: "sacn-info" }
const _hoisted_13 = { class: "form-intro" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "form-tips" }, "先截图，再从微信扫一扫打开添加", -1)

import { onMounted, ref, reactive, nextTick } from "vue";
import type { FormInstance } from "element-plus";
import { ElNotification } from 'element-plus';
import { pickBy } from 'lodash-es';

import Oxpecker from '@/components/Oxpecker/index.vue';
import { getFormDetail, submitForm, getWxInfo, sendCode } from "@/api/form";
import { getUrlParams, isWeixin } from "@/utils/tools";
import FieldRender from '@/components/FieldRender/index.vue';

import "./index.scss";

const APP_ID = 'wx5f3c7eaf772aec8c';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const ruleFormRef = ref<FormInstance>();
const state: any = reactive({
  dialogVisible: false,
  ruleForm: {
    name: ''
  },
  step: 0,
  showCode: false,

  brief: '',
  createTime: '',
  field: [],
  headImageUrl: '',
  introduction: '',
  submittedSettings: {

  },
  appendFields: {}, // 需要追加的字段，从url里读取
  title: '',

  rules: {},

  formId: 0,
  shareId: 0,
  unionId: 0,
  nickName: '',

  formItems: {},

  needFill: true, // 后端记录当前微信用户是否已经填写过，即是否需要填写表单

  submitDisabled: false,
})

onMounted(() => {
  const data: any = getUrlParams();

  state.formId = data.formId - 0;
  state.shareId = data.shareId - 0;

  if (data.shareOut) {
    getFormData();
  } else {
    if (!data.code) {
      if (isWeixin()) {
        const info = window.localStorage.getItem('wx_info');
        let data = null;

        if (info) {
          try {
            data = JSON.parse(info);

            state.unionId = data.unionId;
            state.nickName = data.nickName;

            if (!state.unionId) {
              // 缓存数据异常了
              state.dialogVisible = true;
            } else {
              // 正常流程
              getFormData();
            }
          } catch(e) {
            state.dialogVisible = true;
          }
        } else {
          state.dialogVisible = true;
        }
      } else {
        tipError('请用微信打开该链接');
      }
    } else {
      getCode();
    }
  }

  // if (!data.shareOut && !data.code) {
  //   if (isWeixin()) {
  //     getCode();
  //   } else {
  //     tipError('请用微信打开该链接');
  //     return;
  //   }
  // } else {
  //   getFormData();
  // }
});

function fieldHandle(data) {
  if (data.type === 'validate') {
    handleValidate(data);
  }
}

function handleValidate(data) {
  const fieldId = data.fieldId;
  let index = 0;
  // 先查找需要校验哪个表单
  state.field.forEach((item, ind) => {
    if (fieldId === item.fieldId) {
      index = ind;
    }
  });

  if (index >= 1 && state.field[index - 1].formType === 'mobile') {
    const mobileItem = state.field[index - 1];
    data.mobile = state.formItems[mobileItem.fieldId];

    ruleFormRef.value.validateField(mobileItem.fieldId + '', result => {
      if (result) {
        getValidateCode(data);
      }
    })

    return;
  }
}


async function getValidateCode(data) {
  const [err, res] = await sendCode({
    formId: state.formId,
    mobile: data.mobile,
  });

  if (!err) {
    data.cb();
  }
}

function confirmForm(formEl: FormInstance | undefined) {
  if (!formEl) return;
  formEl.validate((res: any) => {
    if (res) {
      const condition: any = {
        shareId: state.shareId,
        formId: state.formId,
        ...pickBy({
          wxUnionId: state.unionId,
          wxNickName: state.nickName,
        }),
      };

      const resField = state.field.filter((item: any) => {
        if (item.formType === 'validate') {
          condition.verifyCode = state.formItems[item.fieldId];

          return false;
        }
        return (item.fieldId in state.formItems)
      }).map((item: any) => {
        return {
          fieldId: item.fieldId,
          value: state.formItems[item.fieldId],
        };
      });

      condition.fields = resField || []

      if (Object.keys(state.appendFields).length) {
        condition.tpParam = state.appendFields
      }

      state.submitDisabled = true

      submitForm(condition).then(([err]) => {
        state.submitDisabled = false
        if (err) { return }

        afterSubmitForm();
      });
    }
  });
}

function afterSubmitForm() {
  state.step = 2;

  if (state.submittedSettings.submittedType === "SCAN_QR_CODE") {
    state.showCode = true;
  } else if (state.submittedSettings.submittedType === "OTHER_LINK") {
    window.location.href = state.submittedSettings.otherLink;
  }
}

async function getFormData() {
  (window as any).DATracker && (window as any).DATracker.track('market_form_view', {
    formId: state.formId,
    shareId: state.shareId,
  });

  const params: any = {
    formId: state.formId,
  }

  if (state.unionId) {
    // 企微需要去判断，该用户是否填写过
    params.wxUnionId = state.unionId;
  }

  const [err, res] = await getFormDetail(params);
  if (err) {
    return;
  }

  let data = res?.data;

  state.title = data?.title || '';
  state.brief = data?.brief;
  state.headImageUrl = data?.headImageUrl;
  state.introduction = data?.introduction?.replaceAll('\r\n', '<br />');
  state.field = data?.field || [];
  state.submittedSettings = data?.submittedSettings;
  
  state.needFill = !!(data?.needFill);

  handleFields();

  if (!state.needFill) {
    // 用户已填过，不需要填写该表单
    afterSubmitForm();
    return;
  }

  if (data?.callbackConfig?.templateId === 1) {
    // 个人邮直邮（合作） 回传
    const urlParams: any = getUrlParams();

    data.callbackConfig.tpParam.split(',').forEach((key: string) => {
      state.appendFields[key] = urlParams[key] || '';
    })
  }

  document.title = state.title;

  state.field.forEach((item: any) => {
    state.rules[item.fieldId] = [{
      required: !!item.required,
      message: item.displayName,
    }];
    state.ruleForm[item.fieldId] = "";

    if (item.formType === 'mobile') {
      state.rules[item.fieldId].push({
        pattern: /^1\d{10}$/,
        message: '请输入正确的手机',
        trigger: 'blur',
      })
    } else if (item.formType === 'number') {
      state.rules[item.fieldId].push({
        pattern: /^\d*\.?\d*$/,
        message: '请输入正确的值',
        trigger: 'blur',
      })
    }
  });

  nextTick(() => {
    state.step = 1;
  })
}

// 特殊处理field内容
function handleFields() {
  let _fieldId = -1; // 前端自己的id

  for (let index = state.field.length - 1; index >= 0; index--) {
    const item = state.field[index]

    if (item.formType === 'mobile' && item.verifyMobile) {
      // 当手机号需要校验时，需要输入验证码才可以通过
      state.field.splice(index + 1, 0, {
        fieldId: _fieldId--,
        formType: 'validate',
        required: true,
        displayName: '请输入验证码',
      })
    }
  }
}

function getCode() {
  // 非静默授权，第一次有弹框
  state.code = '';
  const local = window.location.href; // 获取页面url
  const appid = APP_ID;
  const data: any = getUrlParams();
  state.code = data.code; // 截取code

  // if (state.code == null || state.code === "") {
  //   state.dialogVisible = true;
  //   // 如果没有code，则去请求
  //   // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
  //   //   local
  //   // )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  // } else {
    // 你自己的业务逻辑
    getWxInfo({ code: state.code }).then(([err, res]) => {
      if (err) throw new Error('获取微信信息失败')
      
      state.unionId = res.data?.unionId || '';
      state.nickName = res.data?.nickName || '';

      getFormData();

      if (state.unionId) {
        window.localStorage.setItem('wx_info', JSON.stringify({
          unionId: state.unionId,
          nickName: state.nickName,
        }));
      }
    });
  // }
  // getFormData();
}

function authorization() {
  const appid = APP_ID;
  const local = window.location.href; // 获取页面url
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
    local
  )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
}

function tipError(msg: string) {
  ElNotification({
    type: 'error',
    title: '错误',
    message: msg,
    position: 'top-right',
    duration: 0,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Oxpecker),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_dialog, {
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.dialogVisible) = $event)),
        title: "",
        width: "300px",
        "show-close": false,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (authorization())),
              style: {"width":"100%","height":"40px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确认 ")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (state.step === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_skeleton, {
              rows: 6,
              animated: ""
            }),
            _createVNode(_component_el_skeleton, {
              rows: 6,
              animated: ""
            })
          ]))
        : _createCommentVNode("", true),
      (state.step === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "head-img",
              src: state.headImageUrl
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, _toDisplayString(state.title), 1),
            _createElementVNode("div", {
              class: "form-intro",
              innerHTML: state.introduction
            }, null, 8, _hoisted_8),
            _createVNode(_component_el_form, {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              model: state.formItems,
              rules: state.rules,
              "label-position": "top",
              "label-width": "300px"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.field, (item) => {
                  return (_openBlock(), _createBlock(_component_el_form_item, {
                    class: "w-full",
                    key: item.fieldId,
                    label: item.displayName,
                    prop: String(item.fieldId)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FieldRender, {
                        style: {"width":"100%"},
                        item: item,
                        modelValue: state.formItems[item.fieldId],
                        "onUpdate:modelValue": ($event: any) => ((state.formItems[item.fieldId]) = $event),
                        onHandle: fieldHandle
                      }, null, 8, ["item", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label", "prop"]))
                }), 128)),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (confirmForm(ruleFormRef.value))),
                      style: {"width":"100%"},
                      disabled: state.submitDisabled
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 提交 ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      (state.step === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(state.submittedSettings.guideText), 1),
              _createElementVNode("img", {
                src: state.submittedSettings.qrcodeUrl,
                width: "160",
                height: "160"
              }, null, 8, _hoisted_14),
              _hoisted_15
            ], 512), [
              [_vShow, state.showCode]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})